import * as yup from 'yup';

interface LifeExpectancyOptions {
  LifeExpectancy: number[];
  PassingAwayToday: number[];
  RemainingYearsUntilPassing: number[];
}

export interface Options {
  LifeExpectancyPrincipalOptions: LifeExpectancyOptions;
  LifeExpectancySpouseOptions: Partial<LifeExpectancyOptions>;
  PrincipalName: string;
  SpouseName?: string;
}

export interface FormValues {
  WhatIfKey: string;
  WhatIfType: number;
  WhatIfTypeName: string;
  LifeExpectancyTypePrincipal: number;
  LifeExpectancyPrincipal: number | string;
  RemainingYearsUntilPassingPrincipal: number | null;
  LifeExpectancyTypeSpouse: number;
  LifeExpectancySpouse: number | string;
  RemainingYearsUntilPassingSpouse: number | string;
}

export enum LifeExpectancyOptionsType {
  PassingAwayToday,
  LifeExpectancy,
  RemainingYearsUntilPassing,
}

export const OptionsDictionary = {
  LifeExpectancy: { label: 'Life Expectancy', value: LifeExpectancyOptionsType.LifeExpectancy },
  PassingAwayToday: {
    label: 'Passing Away Today',
    value: LifeExpectancyOptionsType.PassingAwayToday,
  },
  RemainingYearsUntilPassing: {
    label: 'Remaining Years Until Passing',
    value: LifeExpectancyOptionsType.RemainingYearsUntilPassing,
  },
};

export const FORM_SCHEMA = yup.object().shape({
  RemainingYearsUntilPassingPrincipal: yup
    .number()
    .transform(value => (Number.isNaN(value) ? undefined : value))
    .when('LifeExpectancyTypePrincipal', {
      is: value => value === LifeExpectancyOptionsType.RemainingYearsUntilPassing,
      then: yup
        .number()
        .required('Years Remaining is required')
        .transform(value => (Number.isNaN(value) ? undefined : value))
        .test('lifeExpectancyPrincipal', (value, context) => {
          if (value === undefined || value === null) {
            return false;
          }

          const { LifeExpectancyPrincipalOptions } = context.options.context as Options;

          const { RemainingYearsUntilPassing } = LifeExpectancyPrincipalOptions;

          const maxAge = RemainingYearsUntilPassing.slice(-1)[0];

          if (value < 1 || value > maxAge) {
            return context.createError({
              message: `Enter a value between 1 and ${maxAge}.`,
              path: 'RemainingYearsUntilPassingPrincipal',
            });
          }

          return true;
        }),
    }),

  RemainingYearsUntilPassingSpouse: yup
    .number()
    .transform(value => (Number.isNaN(value) ? undefined : value))
    .when(['LifeExpectancyTypeSpouse', '$SpouseName'], {
      is: (type, spouseName) =>
        type === LifeExpectancyOptionsType.RemainingYearsUntilPassing && !!spouseName,
      then: yup
        .number()
        .required('Years Remaining is required')
        .transform(value => (Number.isNaN(value) ? undefined : value))
        .test('lifeExpectancySpouse', (value, context) => {
          if (value === undefined || value === null) {
            return false;
          }

          const { LifeExpectancySpouseOptions } = context.options.context as Options;

          if (
            LifeExpectancySpouseOptions &&
            LifeExpectancySpouseOptions.LifeExpectancy &&
            LifeExpectancySpouseOptions.RemainingYearsUntilPassing
          ) {
            const { RemainingYearsUntilPassing } = LifeExpectancySpouseOptions;
            const maxAge = RemainingYearsUntilPassing.slice(-1)[0];

            if (value < 1 || value > maxAge) {
              return context.createError({
                message: `Enter a value between 1 and ${maxAge}.`,
                path: 'RemainingYearsUntilPassingSpouse',
              });
            }
          }

          return true;
        }),
    }),
});
